module.exports = __webpack_public_path__ + "static/media/piper-nudging-paw-3.39385cd3.svg";